var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "base-input" },
    [
      _vm.field.type === "select"
        ? _c("ValidationProvider", {
            attrs: { rules: _vm.rules },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function ({ errors }) {
                    return [
                      _c(
                        "b-field",
                        {
                          attrs: {
                            label: _vm.field.label,
                            horizontal: _vm.field.isHorizontal,
                            type: errors[0] ? "is-danger" : "",
                            message: errors[0],
                          },
                        },
                        [
                          _c(
                            "b-select",
                            {
                              attrs: {
                                id: _vm.id,
                                "data-cy": `base-input-select-${_vm.id}`,
                                placeholder: _vm.field.placeholder,
                                size: _vm.field.size
                                  ? _vm.field.size
                                  : "is-small",
                                expanded: "",
                              },
                              model: {
                                value: _vm.localValue,
                                callback: function ($$v) {
                                  _vm.localValue = $$v
                                },
                                expression: "localValue",
                              },
                            },
                            _vm._l(_vm.field.options, function (option) {
                              return _c(
                                "option",
                                {
                                  key: option.value,
                                  domProps: { value: option.value },
                                },
                                [_vm._v(" " + _vm._s(option.label) + " ")]
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              3901855288
            ),
          })
        : _vm.field.type === "switch"
        ? _c("ValidationProvider", {
            attrs: { rules: _vm.rules },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ errors }) {
                  return [
                    _c(
                      "b-field",
                      {
                        attrs: {
                          label: _vm.field.label,
                          horizontal: _vm.field.isHorizontal,
                        },
                      },
                      [
                        _c(
                          "b-switch",
                          {
                            attrs: {
                              id: _vm.id,
                              "data-cy": `base-input-switch-${_vm.id}`,
                              size: _vm.field.size
                                ? _vm.field.size
                                : "is-small",
                            },
                            model: {
                              value: _vm.localValue,
                              callback: function ($$v) {
                                _vm.localValue = $$v
                              },
                              expression: "localValue",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  !_vm.field.isHorizontal
                                    ? _vm.field.placeholder
                                    : ""
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c("p", { staticClass: "help is-danger" }, [
                      _vm._v(_vm._s(errors[0])),
                    ]),
                  ]
                },
              },
            ]),
          })
        : _vm.field.type === "number"
        ? _c("ValidationProvider", {
            attrs: { rules: _vm.rules },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ errors }) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "field has-addons",
                        class: {
                          "is-horizontal": _vm.field.isHorizontal,
                          "is-small": !_vm.field.size,
                          [_vm.field.size]: _vm.field.size,
                        },
                      },
                      [
                        _vm.field.title
                          ? _c("div", { staticClass: "field-title" }, [
                              _c("small", [_vm._v(_vm._s(_vm.field.title))]),
                            ])
                          : _vm._e(),
                        _vm.field.label
                          ? _c("div", { staticClass: "field-label" }, [
                              _c("label", { staticClass: "label" }, [
                                _vm._v(_vm._s(_vm.field.label)),
                              ]),
                            ])
                          : _vm._e(),
                        _c("div", { staticClass: "field-body" }, [
                          _vm.field.prefixPosition === "left" &&
                          _vm.field.prefix
                            ? _c("div", { staticClass: "control" }, [
                                _c("p", { staticClass: "pos-left" }, [
                                  _c(
                                    "span",
                                    { staticClass: "button is-static" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.field.prefix !== ""
                                            ? _vm.field.prefix
                                            : ""
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "control" },
                            [
                              _c("b-input", {
                                attrs: {
                                  id: _vm.id,
                                  size: _vm.field.size
                                    ? _vm.field.size
                                    : "is-small",
                                  "data-cy": `base-input-number-${_vm.id}`,
                                  type: "number",
                                  min: "0",
                                  icon: _vm.field.icon,
                                  placeholder: _vm.field.placeholder,
                                  expanded: "",
                                },
                                model: {
                                  value: _vm.localValue,
                                  callback: function ($$v) {
                                    _vm.localValue = $$v
                                  },
                                  expression: "localValue",
                                },
                              }),
                              _c("p", { staticClass: "help is-danger" }, [
                                _vm._v(_vm._s(errors[0])),
                              ]),
                            ],
                            1
                          ),
                          _vm.field.prefixPosition === "right" &&
                          _vm.field.prefix
                            ? _c("div", { staticClass: "control" }, [
                                _c("p", { staticClass: "pos-right" }, [
                                  _c(
                                    "span",
                                    { staticClass: "button is-static" },
                                    [_vm._v(_vm._s(_vm.field.prefix))]
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          })
        : _c("ValidationProvider", {
            attrs: { rules: _vm.rules },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ errors }) {
                  return [
                    _c(
                      "b-field",
                      {
                        attrs: {
                          label: _vm.field.label,
                          horizontal: _vm.field.isHorizontal,
                          type: errors[0] ? "is-danger" : "",
                          message: errors[0],
                        },
                      },
                      [
                        _c("b-input", {
                          attrs: {
                            id: _vm.id,
                            "data-cy": `base-input-text-${_vm.id}`,
                            placeholder: _vm.field.placeholder,
                            size: _vm.field.size ? _vm.field.size : "is-small",
                            type: "text",
                            icon: _vm.field.icon,
                            expanded: "",
                          },
                          model: {
                            value: _vm.localValue,
                            callback: function ($$v) {
                              _vm.localValue = $$v
                            },
                            expression: "localValue",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }